export var freeze = function (obj) { return Object.freeze(obj); };



//////////////////
// WEBPACK FOOTER
// /Users/jordan/www/sites/chryso/wwwroot/wp-content/themes/chryso-v2/node_modules/@juggle/resize-observer/lib/utils/freeze.js
// module id = 54
// module chunks = 0